import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { ToastProvider } from "./components/Toast.js";
import { AuthProvider } from "./lib/auth-context.js";
import { createQueryClient } from "./lib/polling.js";
import { applyTheme, readTheme } from "./lib/theme.js";
import "./styles/app.css";

applyTheme(readTheme());

const container = document.getElementById("root");
if (!container) throw new Error("no #root element to mount into");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <BrowserRouter>
        <AuthProvider>
          {/* Inside the router, so a confirmation raised by an action survives the navigation
              that action may cause. */}
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
